import { AnyAction } from 'redux';
import { ILoadingError } from '#/types/global';
import {
  IPlaylistResponse,
  PlaylistItem,
  PlaylistTrack,
  PlaylistTracks,
} from '#/types/API/playlist';
import {
  createActionPlaylistReset,
  createActionPlaylistSetError,
  createActionPlaylistSetIsLiked,
  createActionPlaylistSetPlaylist,
  createActionPlaylistSetTrackFavorite,
  createActionPlaylistSetTracks,
  createActionPlaylistStartLoading,
  createActionPlaylistStopLoading,
} from '../actions/playlist';

interface ICustomTrack extends PlaylistTrack {
  favorite: boolean;
}

interface ICustomItem extends PlaylistItem {
  track: ICustomTrack;
}

interface ICustomTracks extends PlaylistTracks {
  items: ICustomItem[];
}

export interface IPlaylistWithFavorite extends IPlaylistResponse {
  liked: boolean;
  tracks: ICustomTracks;
}

export interface IPlaylistState {
  playlist?: IPlaylistWithFavorite;
}

type TState = IPlaylistState & ILoadingError;

const initialState: TState = {
  _loading: true,
  _error: false,
};

const playlist = (state: TState = initialState, action: AnyAction): TState => {
  if (createActionPlaylistSetPlaylist.doesMatch(action)) {
    return { ...state, playlist: action.payload };
  }

  if (createActionPlaylistStartLoading.doesMatch(action)) {
    return { ...state, _loading: true };
  }

  if (createActionPlaylistStopLoading.doesMatch(action)) {
    return { ...state, _loading: false };
  }

  if (createActionPlaylistSetError.doesMatch(action)) {
    return { ...state, _error: action.payload };
  }

  if (createActionPlaylistSetIsLiked.doesMatch(action)) {
    if (state.playlist) {
      return {
        ...state,
        playlist: {
          ...state.playlist,
          followers: {
            ...state.playlist.followers,
            total: action.payload.liked
              ? state.playlist.followers.total + 1
              : state.playlist.followers.total - 1,
          },
          liked: action.payload.liked,
        },
      };
    }
    return state;
  }

  if (createActionPlaylistSetTrackFavorite.doesMatch(action)) {
    if (state.playlist) {
      const indexTrack = state.playlist.tracks.items.findIndex(
        (item) => item.track.id === action.payload.track
      );
      if (indexTrack !== -1) {
        const newItems = [...state.playlist.tracks.items];
        newItems[indexTrack].track.favorite = action.payload.favorite;
        return {
          ...state,
          playlist: {
            ...state.playlist,
            tracks: { ...state.playlist.tracks, items: newItems },
          },
        };
      }
    }
    return state;
  }

  if (createActionPlaylistSetTracks.doesMatch(action)) {
    if (state.playlist) {
      return {
        ...state,
        playlist: {
          ...state.playlist,
          tracks: { ...state.playlist.tracks, items: action.payload.tracks },
        },
      };
    }
    return state;
  }

  if (createActionPlaylistReset.doesMatch(action)) {
    return initialState;
  }

  return state;
};

export default playlist;
